module.exports = __webpack_public_path__ + "img/top_explanation.e3addfe1.png";